<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Sagsbehandler</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Fjern fra afviste og arkiverede sager</dt>
        <dd>{{value.remove_delay}} dag(e)</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="45" class="settings-list">
        <dt>Send daglig "Tildelte sager"-mail</dt>
        <dd>{{value.daily_reminder ? 'Ja' : 'Nej' }}</dd>
      </dl>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" class="mb-3">
        <div fxFlex="45" fxLayout="column">
          <label>Fjern fra afviste og arkiverede sager (dage)</label>
          <mat-form-field>
            <input type="number" matInput formControlName="remove_delay">
            <mat-hint>Antal dage før sagsbehandleren fjernes fra arkiverede og afviste sager.</mat-hint>
            @if (form.controls['remove_delay'].hasError('required')) {
              <mat-error>Obligatorisk.</mat-error>
            }
            @if (form.controls['remove_delay'].hasError('min')) {
              <mat-error>Mindst 1 dag.</mat-error>
            }
          </mat-form-field>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div fxFlex="45" fxLayout="column">
          <mat-slide-toggle
            formControlName="daily_reminder"
          >Send daglig "Tildelte sager"-mail</mat-slide-toggle>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
